import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchDashboardOnMutationSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const DASHBOARD_MUTATION_TOOL_NAMES = [
    'apply_dashboard',
    'save_dashboard_panel',
    'save_number_panel',
    'save_time_series_panel',
    'save_bar_panel',
    'save_histogram_panel',
    'save_table_panel',
    'remove_dashboard_panel',
];

const buildRefetchDashboardOnMutationSubscription = (
    _params: BuildRefetchDashboardOnMutationSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-dashboard-on-mutation',
        routePattern: '/agents/:agentId/dashboards/:dashboardId',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (!eventMatchesToolNames({ event, toolNames: DASHBOARD_MUTATION_TOOL_NAMES })) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const mutatedDashboardId = getStringValue({ value: args.dashboardId });

            // TOOL_CALL_RESULT events sometimes omit args; assume the mutation targets the
            // dashboard currently in view when we cannot read an explicit dashboardId.
            if (!mutatedDashboardId) {
                return true;
            }

            return mutatedDashboardId === matchParams.dashboardId;
        },
        action: ({ queryClient, matchParams }) => {
            queryClient.invalidateQueries(['dashboard-data', matchParams.dashboardId]);
            queryClient.invalidateQueries(['dashboard', matchParams.dashboardId]);
        },
    };
};

export default buildRefetchDashboardOnMutationSubscription;
